import styled from 'styled-components';
import { borderRadius, colorUsage, fontSize, getSpacing } from 'stylesheet';
import { Delete } from 'theme/icons';
var SelectedContentContainer = styled.div.withConfig({
  displayName: "ContentPreviewstyle__SelectedContentContainer",
  componentId: "sc-8umx3u-0"
})(["position:relative;display:flex;flex-direction:column;align-items:flex-start;width:100%;margin:", ";"], getSpacing(2));
var DeleteContentButton = styled(Delete).withConfig({
  displayName: "ContentPreviewstyle__DeleteContentButton",
  componentId: "sc-8umx3u-1"
})(["position:absolute;top:-", ";right:-", ";border:2px solid ", ";border-radius:", ";cursor:pointer;& circle{fill:", ";}"], getSpacing(1), getSpacing(1), colorUsage.imageDeleteButtonBorder, borderRadius.medium, colorUsage.imageDeleteButtonBackground);
var CheckboxesContainer = styled.div.withConfig({
  displayName: "ContentPreviewstyle__CheckboxesContainer",
  componentId: "sc-8umx3u-2"
})(["display:flex;width:100%;margin:", " auto;"], getSpacing(2));
var CheckboxContainer = styled.div.withConfig({
  displayName: "ContentPreviewstyle__CheckboxContainer",
  componentId: "sc-8umx3u-3"
})(["&:not(:first-child){margin-left:", ";}"], getSpacing(2));
var Img = styled.img.withConfig({
  displayName: "ContentPreviewstyle__Img",
  componentId: "sc-8umx3u-4"
})(["max-width:100%;height:auto;border-radius:", ";"], borderRadius.large);
var Label = styled.span.withConfig({
  displayName: "ContentPreviewstyle__Label",
  componentId: "sc-8umx3u-5"
})(["margin:", " auto;font-size:", ";text-align:center;"], getSpacing(2), fontSize.large);
export { CheckboxContainer, CheckboxesContainer, DeleteContentButton, SelectedContentContainer, Img, Label };